
    import '/Users/jilin/projects/antd/rc-dialog/docs/demo/bootstrap.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-bootstrap-demo-bootstrap"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/jilin/projects/antd/rc-dialog/docs/demo/bootstrap.md?type=demo')
};